import { useTranslation } from "react-i18next";

/**
 * AnswerPeriodEndedScreen — 回答期限超過を伝える案内画面 (ADR-0032・ADR-0061)。
 *
 * SurveyForm の 409 (提出時点の期限超過) は文言の異なる AnswerClosedScreen が担う。
 */
export function AnswerPeriodEndedScreen() {
  const { t } = useTranslation("respond");
  return (
    <section className="rounded-lg border border-border bg-card p-6 shadow-sm">
      <h1 className="text-base font-semibold">{t("session.answerClosedTitle")}</h1>
      <p className="mt-2 text-sm text-muted-foreground">{t("session.answerClosedDescription")}</p>
    </section>
  );
}
